import { hashKey, type QueryClient } from "@tanstack/react-query";

export type OpenedTimeOff = { target: "staff" | "resource"; id: number };

/**
 * The opened row can be gone after the write (a delete, or a series rewrite),
 * so it is only marked stale: refetching it would 404 into an error toast.
 */
export async function refreshAfterTimeOffWrite(
  queryClient: QueryClient,
  opened: OpenedTimeOff | null,
): Promise<void> {
  const openedKey = ["timeoff", "occurrence", opened];
  const openedHash = hashKey(openedKey);

  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: ["timeoff"],
      predicate: (query) => query.queryHash !== openedHash,
    }),
    queryClient.invalidateQueries({
      queryKey: openedKey,
      exact: true,
      refetchType: "none",
    }),
    queryClient.invalidateQueries({ queryKey: ["staff-timeoff-list"] }),
  ]);
}

/** Any open occurrence may be the one just deleted, so occurrences are only marked stale. */
export async function refreshTimeOffLists(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: ["timeoff"],
      predicate: (query) => query.queryKey[1] !== "occurrence",
    }),
    queryClient.invalidateQueries({
      queryKey: ["timeoff", "occurrence"],
      refetchType: "none",
    }),
  ]);
}
